// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "web-worker/" + {"393":"duplexer","478":"wix-comments-controller","719":"localization-api","730":"lazy-actions"}[chunkId] + ".chunk.min.js";
};